/* SearchDropdownEmbedded.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["showFocused"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["isPlaceHolder"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _40 = "._154i1p2n{top:2.875rem}";
const _39 = "._2rkov47k{border-radius:var(--ds-space-250,20px)}";
const _38 = "._1ygb1a9f:focus-visible{outline:var(--_1kmg6zk)}";
const _37 = "._1wpz1fhb{align-self:stretch}";
const _36 = "._1bah1yb4{justify-content:space-between}";
const _35 = "._1wybpxbi{font-size:var(--ds-space-200,1pc)}";
const _34 = "._vwz4pxbi{line-height:var(--ds-space-200,1pc)}";
const _33 = "._4t3i13ei{height:2.625rem}";
const _32 = "._1yt4yyd7{padding:var(--_hnbm3m)}";
const _31 = "._bfhk18uv{background-color:initial}";
const _30 = "._19it1k8u{border:var(--_yizpff)}";
const _29 = "._2rko1jfw{border-radius:var(--ds-space-500,40px)}";
const _28 = "._syaz1kw7{color:inherit}";
const _27 = "._1ygbugt7:focus-visible{outline:2px solid var(--ds-border-focused,#388bff)}";
const _26 = "._1wyb1j6v{font-size:1rem}";
const _25 = "._vwz41j6v{line-height:1rem}";
const _24 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _23 = "._1yt419h1{padding:var(--ds-space-100,8px) var(--ds-space-400,2pc) var(--ds-space-100,8px) var(--ds-space-200,1pc)}";
const _22 = "._11q71j9a{background:var(--ds-background-input,#fff)}";
const _21 = "._19it1ozg{border:2px solid var(--ds-border-input,#8590a2)}";
const _20 = "._16qs1402{box-shadow:0 0 1px 0 rgba(9,30,66,.31),0 3px 5px 0 rgba(9,30,66,.2)}";
const _19 = "._1pbykb7n{z-index:1}";
const _18 = "._154i1ady{top:44px}";
const _17 = "._kqswstnw{position:absolute}";
const _16 = "._1bsb1osq{width:100%}";
const _15 = "._bfhk1bhr{background-color:var(--ds-surface-overlay,#fff)}";
const _14 = "._2rkoftgi{border-radius:8px}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import SearchIcon from '@atlaskit/icon/glyph/search';
import { media } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { useHistory, useLocationHref, useQueryParams } from '@atlassian/mpac-ui';
import { useMountPath, useSource } from '@atlassian/mpac-utils';
import React, { useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useAlgoliaAutocomplete } from '../../AlgoliaClientSDK/useAlgoliaAutocomplete';
import { getSuggestionSource } from '../../AnalyticsUtils';
import { embeddedPlaceholder, inProductPlaceholder, mobilePlaceholder } from '../../constants';
import { RecentSearch } from '../../SearchUtils';
import { restoreFocusAndTab } from '../../SearchUtils/domHandlersUtils';
import { redirectToNewQuery } from '../../SearchUtils/search-navigation-utils/SearchNavigationUtils';
import { SearchBodyFactory } from '../SearchBodyFactory';
import { SearchHeader } from '../SearchHeader';
import { useAutocompleteState } from './hooks/useAutocompleteState';
import { useFollowElementPosition } from './hooks/useFollowElementPosition';
import { useOutsideClick } from './hooks/useOutsideClick';
import { useSearchDropdown } from './hooks/useSearchDropdown';
import { useSearchViewAnalytics } from './hooks/useSearchViewAnalytics';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _13 = "._1h6d1elr{border-color:var(--ds-border-input,#8590a2)}";
const _12 = "._1h6d1yqz{border-color:var(--ds-border-selected,#0c66e4)}";
const _11 = "@media (min-width:64rem){._1yag1bs6{padding:var(--ds-space-100,8px) var(--ds-space-150,9pt)}}";
const _10 = "._4cvr1h6o{align-items:center}";
const _9 = "._bfhkvuon{background-color:var(--ds-surface,#fff)}";
const _8 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _7 = "._vchhusvi{box-sizing:border-box}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "._4t3i1ylp{height:40px}";
const _4 = "._19it1axk{border:2px solid}";
const _3 = "._2rkoi2wt{border-radius:6px}";
const _2 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _ = "._1yt4u2gc{padding:var(--ds-space-100,8px)}";
const Header = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      showFocused
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4u2gc _zulpu2gc _2rkoi2wt _19it1axk _4t3i1ylp _1e0c1txw _vchhusvi _syaz131l _bfhkvuon _4cvr1h6o _1yag1bs6", __cmplp.showFocused ? "_1h6d1yqz" : "_1h6d1elr", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
const SearchBodyWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_14, _15, _16, _17, _18, _19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkoftgi _bfhk1bhr _1bsb1osq _kqswstnw _154i1ady _1pbykb7n _16qs1402", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchBodyWrapper.displayName = 'SearchBodyWrapper';
}
const SearchBodyWrapperStyleWC = null;
const SearchEmbeddedDropdown = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchEmbeddedDropdown.displayName = 'SearchEmbeddedDropdown';
}
const SearchButtonMobile = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded5);
  const {
      isPlaceHolder
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3, _21, _22, _23, _6, _5, _16, _24, _25, _26, _10, _27, _8, _28]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _2rkoi2wt _19it1ozg _11q71j9a _1yt419h1 _1e0c1txw _4t3i1ylp _1bsb1osq _ect418aq _vwz41j6v _1wyb1j6v _4cvr1h6o _1ygbugt7", __cmplp.isPlaceHolder ? "_syaz131l" : "_syaz1kw7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchButtonMobile.displayName = 'SearchButtonMobile';
}
const SearchButtonMobileStyle = null;
const isPlaceHolderSearchButtonStyle = null;
const HeaderStyle = null;
const showFocusedHeaderStyle = null;

// RECENT SEARCH HANDLINGS
const recentSearch = new RecentSearch(5, 'mpac-search-recent-searches');
const OFFSET_Y_SEARCH_BODY = 46;

// eslint-disable-next-line max-lines-per-function, complexity
export function SearchDropdownEmbedded(_ref5) {
  var _searchPlaceholder$de;
  let {
    searchInputRef,
    onInputFocus,
    onViewed,
    onSuggestionSelection,
    onEnterKeyPress,
    additionalQueryParams,
    searchPlaceholder
  } = _ref5;
  const searchembeddedRef = useRef(null);
  const searchBodyRef = useRef(null);
  const clearRecentSearchRef = useRef(null);
  const [showSuggestionPopup, setShowSuggestionPopup] = React.useState(false);
  const [showFocused, setShowFocused] = React.useState(false);
  const searchSuggestionCountRef = useRef(0);
  const hasFiredViewedAnalyticsRef = useRef(false);
  const source = useSource();
  const mountPath = useMountPath();

  // LOCATION HANDLINGS
  const {
    query: queryFromUrl
  } = useQueryParams();
  const locationHref = useLocationHref();
  const history = useHistory();

  // AUTOCOMPLETE HANDLINGS
  const ref = useRef(null);
  const inputRef = searchInputRef !== null && searchInputRef !== void 0 ? searchInputRef : ref;

  // Handling the position for search results
  const dropDownPos = useFollowElementPosition(searchembeddedRef, showSuggestionPopup, OFFSET_Y_SEARCH_BODY);
  const handleNewSearch = useCallback(hit => {
    var _inputRef$current, _hit$__autocomplete_i, _inputRef$current2;
    const inputValue = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value;
    onSuggestionSelection({
      query: hit.query,
      position: ((_hit$__autocomplete_i = hit.__autocomplete_id) !== null && _hit$__autocomplete_i !== void 0 ? _hit$__autocomplete_i : 0) + 1,
      popularity: hit.popularity,
      suggestionSource: getSuggestionSource(!!inputValue),
      count: inputValue ? searchSuggestionCountRef.current : recentSearch.count()
    });
    recentSearch.push(hit);

    // The following code resolves a bug experienced in SRP. Previously, when the input field text was cleared,
    // reselecting the same text from the recent search list did not repopulate the input field.
    // The function setQuery() is used to set the selected hit in the autocomplete object.
    autocomplete.setQuery(hit.query);
    redirectToNewQuery({
      query: hit.query,
      locationHref,
      history,
      additionalQueryParams,
      source,
      mountPath
    });
    setShowSuggestionPopup(false);
    inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.blur();
  }, [onSuggestionSelection, locationHref, history, additionalQueryParams]);
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.md;
  const showFullScreenComponent = breakpoint <= breakpointValues.sm;
  const {
    autocomplete,
    autocompleteState
  } = useAlgoliaAutocomplete(inputRef,
  // we only need to set the placeholder for the desktop view using Algolia Client SDK,
  // for mobile view a button is rendered which opens SearchDropdownOverlay Component
  source === 'PRODUCT' ? inProductPlaceholder : (_searchPlaceholder$de = searchPlaceholder === null || searchPlaceholder === void 0 ? void 0 : searchPlaceholder.desktop) !== null && _searchPlaceholder$de !== void 0 ? _searchPlaceholder$de : embeddedPlaceholder, queryFromUrl, handleNewSearch, recentSearch);

  // hide suggestions on clicking outside search embedded component
  useOutsideClick([searchembeddedRef, searchBodyRef], () => setShowSuggestionPopup(false));
  const {
    handleAppend,
    handleEnterKeyPress,
    clearRecentSearches,
    clearSearchInput
  } = useSearchDropdown({
    inputRef,
    autocomplete,
    autocompleteState,
    recentSearch,
    onEnterKeyPress,
    additionalQueryParams
  });

  // BODY STATE HANDLINGS
  const {
    bodyState
  } = useAutocompleteState({
    autocompleteState
  });
  const searchSuggestionProps = {
    hits: autocompleteState.collections,
    autocomplete,
    onAppend: handleAppend
  };
  useEffect(() => {
    var _autocompleteState$co, _autocompleteState$co2, _autocompleteState$co3;
    searchSuggestionCountRef.current = (_autocompleteState$co = (_autocompleteState$co2 = autocompleteState.collections[0]) === null || _autocompleteState$co2 === void 0 ? void 0 : (_autocompleteState$co3 = _autocompleteState$co2.items) === null || _autocompleteState$co3 === void 0 ? void 0 : _autocompleteState$co3.length) !== null && _autocompleteState$co !== void 0 ? _autocompleteState$co : 0;
  }, [bodyState, autocompleteState]);
  useSearchViewAnalytics({
    showSuggestionPopup,
    inputRef,
    isQueryFromUrl: !!queryFromUrl,
    onViewed,
    recentSearch,
    hasFiredViewedAnalyticsRef,
    autocompleteState,
    bodyState
  });
  const showSuggestionView = useCallback(() => {
    hasFiredViewedAnalyticsRef.current = false;
    setShowSuggestionPopup(true);
    setShowFocused(true);
    if (showFullScreenComponent) {
      onInputFocus();
    }
  }, [onInputFocus, showFullScreenComponent]);
  const onKeyDown = e => {
    if (e.key === 'Tab' && e.shiftKey) {
      var _inputRef$current3;
      setShowSuggestionPopup(false);
      (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.blur();
    }
    if (e.key === 'ArrowDown') {
      showSuggestionView();
    }
  };
  const onKeyDownHandler = e => {
    if (e.key === 'Tab') {
      var _inputRef$current4;
      setShowSuggestionPopup(false);
      (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.blur();
    }
  };
  const onKeyDownForRecentSearchHandler = e => {
    if (e.key === 'Tab' && !e.shiftKey) {
      restoreFocusAndTab(inputRef);
    } else if (e.key === 'Tab' && e.shiftKey) {
      var _inputRef$current5;
      e.preventDefault();
      e.stopPropagation();
      (_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.focus();
    }
  };
  const onFocus = () => {
    if (!isMobile) {
      showSuggestionView();
    }
  };
  const onBlur = e => {
    if (isMPACConfiguratorEnabled) {
      if (searchembeddedRef.current && !searchembeddedRef.current.contains(e.relatedTarget) && searchBodyRef.current && !searchBodyRef.current.contains(e.relatedTarget)) {
        setShowSuggestionPopup(false);
      }
    } else if (searchembeddedRef.current && !searchembeddedRef.current.contains(e.relatedTarget)) {
      setShowSuggestionPopup(false);
    }
  };
  const onFormSubmit = query => {
    handleEnterKeyPress(query);
    setShowSuggestionPopup(false);
  };
  const onInputKeyDownHandler = e => {
    if (!isMPACConfiguratorEnabled) return;
    if (e.key === 'Tab' && !e.shiftKey) {
      var _inputRef$current6;
      if (clearRecentSearchRef.current && !((_inputRef$current6 = inputRef.current) !== null && _inputRef$current6 !== void 0 && _inputRef$current6.value)) {
        var _clearRecentSearchRef;
        e.preventDefault();
        (_clearRecentSearchRef = clearRecentSearchRef.current) === null || _clearRecentSearchRef === void 0 ? void 0 : _clearRecentSearchRef.focus();
      }
    }
  };
  const {
    value: searchText
  } = autocomplete.getInputProps({
    inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
  });
  const {
    enableMpacWebCoherence,
    enableMpacConfigurator
  } = useStatsig();
  const isMPACWebCoherenceEnabled = enableMpacWebCoherence();
  const isMPACConfiguratorEnabled = enableMpacConfigurator();
  if (isMobile) {
    if (isMPACWebCoherenceEnabled) {
      return /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_2, _29, _30, _31, _32, _6, _33, _16, _24, _34, _35, _28, _10, _36, _37, _38, _8]
        }), /*#__PURE__*/_jsxs("button", {
          onClick: showSuggestionView,
          "aria-label": "Search",
          className: ax(["_zulpu2gc _2rko1jfw _19it1k8u _bfhk18uv _1yt4yyd7 _1e0c1txw _4t3i13ei _1bsb1osq _ect418aq _vwz4pxbi _1wybpxbi _syaz1kw7 _4cvr1h6o _1bah1yb4 _1wpz1fhb _1ygb1a9f", !searchText && "_syaz131l"]),
          style: {
            "--_yizpff": ix("var(--ds-space-025, 2px)".concat(" solid ", "var(--ds-border, #091E4224)")),
            "--_hnbm3m": ix("var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-300, 24px)")),
            "--_1kmg6zk": ix("var(--ds-space-025, 2px)".concat(" solid ", "var(--ds-border-focused, #388BFF)"))
          },
          children: [searchText || (searchPlaceholder === null || searchPlaceholder === void 0 ? void 0 : searchPlaceholder.mobile) || mobilePlaceholder, /*#__PURE__*/_jsx(SearchIcon, {
            label: "search"
          })]
        })]
      });
    }
    return /*#__PURE__*/_jsxs(SearchButtonMobile, {
      onClick: showSuggestionView,
      "aria-label": "Search",
      isPlaceHolder: !searchText,
      children: [/*#__PURE__*/_jsx(SearchIcon, {
        label: "search"
      }), searchText || (searchPlaceholder === null || searchPlaceholder === void 0 ? void 0 : searchPlaceholder.mobile) || mobilePlaceholder]
    });
  }
  return /*#__PURE__*/_jsxs(SearchEmbeddedDropdown, {
    ref: searchembeddedRef,
    onBlur: onBlur,
    tabIndex: -1,
    onKeyDown: onKeyDown,
    children: [isMPACWebCoherenceEnabled ? /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_32, _31, _29, _30, _6, _33, _16, _36, _10, _37, _12]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_1yt4yyd7 _bfhk18uv _2rko1jfw _19it1k8u _1e0c1txw _4t3i13ei _1bsb1osq _1bah1yb4 _4cvr1h6o _1wpz1fhb", showFocused && "_1h6d1yqz"]),
        style: {
          "--_hnbm3m": ix("var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-300, 24px)")),
          "--_yizpff": ix("var(--ds-space-025, 2px)".concat(" solid ", "var(--ds-border, #091E4224)"))
        },
        children: /*#__PURE__*/_jsx(SearchHeader, {
          autocomplete: autocomplete,
          ref: inputRef,
          handleEnterKeyPress: onFormSubmit,
          clearSearchInput: clearSearchInput,
          onBlur: () => setShowFocused(false),
          onFocus: onFocus,
          isEmbedded: true,
          showFullScreenComponent: showFullScreenComponent,
          onClearTextKeyDown: onKeyDownHandler,
          onKeyDown: onInputKeyDownHandler
        })
      })]
    }) : /*#__PURE__*/_jsx(Header, {
      showFocused: showFocused,
      children: /*#__PURE__*/_jsx(SearchHeader, {
        autocomplete: autocomplete,
        ref: inputRef,
        handleEnterKeyPress: onFormSubmit,
        clearSearchInput: clearSearchInput,
        onBlur: () => setShowFocused(false),
        onFocus: onFocus,
        isEmbedded: true,
        showFullScreenComponent: showFullScreenComponent,
        onClearTextKeyDown: onKeyDownHandler
      })
    }), isMPACConfiguratorEnabled ? /*#__PURE__*/_jsx(_Fragment, {
      children: showSuggestionPopup && /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_39, _40]
        }), /*#__PURE__*/_jsx(SearchBodyWrapper, {
          tabIndex: -1,
          ref: searchBodyRef,
          role: "status",
          "aria-live": "assertive",
          "aria-relevant": "additions",
          style: {
            top: "".concat(dropDownPos.top, "px"),
            left: "".concat(dropDownPos.left, "px"),
            width: "".concat(dropDownPos.width, "px")
          },
          className: ax([isMPACWebCoherenceEnabled && "_2rkov47k _154i1p2n"]),
          children: /*#__PURE__*/_jsx(SearchBodyFactory, {
            type: bodyState,
            searchQuerySuggestionsBodyProps: _objectSpread({
              query: autocompleteState.query
            }, searchSuggestionProps),
            searchLoadingProps: {
              query: autocompleteState.query
            },
            recentSearchBodyProps: _objectSpread(_objectSpread({
              onClearAll: clearRecentSearches,
              onKeyDown: onKeyDownForRecentSearchHandler,
              closeOverlay: () => setShowFocused(false)
            }, searchSuggestionProps), {}, {
              clearRecentSearchRef
            }),
            noSuggestionsBodyProps: {
              query: autocompleteState.query
            }
          })
        })]
      }), document.body)
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: showSuggestionPopup && /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_39, _40]
        }), /*#__PURE__*/_jsx(SearchBodyWrapper, {
          role: "status",
          "aria-live": "assertive",
          "aria-relevant": "additions",
          className: ax([isMPACWebCoherenceEnabled && "_2rkov47k _154i1p2n"]),
          children: /*#__PURE__*/_jsx(SearchBodyFactory, {
            type: bodyState,
            searchQuerySuggestionsBodyProps: _objectSpread({
              query: autocompleteState.query
            }, searchSuggestionProps),
            searchLoadingProps: {
              query: autocompleteState.query
            },
            recentSearchBodyProps: _objectSpread({
              onClearAll: clearRecentSearches,
              closeOverlay: () => setShowFocused(false)
            }, searchSuggestionProps),
            noSuggestionsBodyProps: {
              query: autocompleteState.query
            }
          })
        })]
      })
    })]
  });
}